import styled, { css } from 'styled-components';
import { ReactComponent as ChevronRightIcon } from 'assets/img/icons/chevron-right.svg';
import { th } from 'style/theme';
import { sizes } from 'style';

export const ChevronButtonWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  padding-right: 48px;
  cursor: pointer;
  transition: 200ms;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    `};

  @media ${sizes.desktop} {
    border-radius: 16px;

    ${({ $isOpen }) =>
      $isOpen &&
      css`
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      `};
  }

  ${({ color }) =>
    color &&
    css`
      background-color: ${th(`colors.${color}`)};
    `};
`;

export const Chevron = styled(ChevronRightIcon)`
  position: absolute;
  top: 50%;
  right: 16px;
  fill: ${th('colors.pickledBluewood')};
  transform: translateY(-50%);
  transition: 200ms;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      transform: translateY(-50%) rotate3d(0, 0, 1, 90deg);
    `};
`;
